// Com o driver `username` o nome exibido é o próprio username, então o
// nickname (flarum/nicknames) ocupa a segunda linha no lugar do @handle.
export default function secondaryName(user) {
  if (!user) return null;
  const displayName = user.displayName();
  const username = user.username();
  if (displayName === username) {
    const nickname = typeof user.verifiedNickname === 'function' ? user.verifiedNickname() : null;
    if (nickname && nickname !== displayName) return nickname;
  }
  return '@' + username;
}
flarum.reg.add('ramon-verified', 'common/utils/secondaryName', secondaryName);